// extracted by mini-css-extract-plugin
export default {"name":"Name_name__6k+8G"};